export function generateInitialsAvatar(username: string): string {
  // Obtenir la première lettre du nom d'utilisateur
  const initial = (username || '?').charAt(0).toUpperCase();
  
  // Générer une couleur de fond unique basée sur l'initiale
  const hue = initial.charCodeAt(0) * 137.508; // Multiplier par un nombre premier pour plus de variation
  const backgroundColor = `hsl(${hue}, 70%, 50%)`;
  
  // Créer un canvas pour dessiner l'avatar
  const canvas = document.createElement('canvas');
  canvas.width = 200;
  canvas.height = 200;
  const ctx = canvas.getContext('2d');
  
  if (ctx) {
    // Dessiner le fond
    ctx.fillStyle = backgroundColor;
    ctx.fillRect(0, 0, 200, 200);
    
    // Dessiner l'initiale
    ctx.fillStyle = 'white';
    ctx.font = 'bold 100px Arial';
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';
    ctx.fillText(initial, 100, 100);
  }
  
  return canvas.toDataURL();
} 